import { ArrowUpRight, LifeBuoy } from "lucide-react";
import { Reveal, SectionTag, scrollToId } from "./Reveal";

const SCENARIOS = [
  "Your existing supplier cannot fulfill",
  "Demand unexpectedly increases",
  "Supply becomes constrained",
  "Your supplier increases price or changes terms",
  "You need supply in a new location",
  "You need emergency procurement",
];

export default function BackupSupply() {
  return (
    <section id="backup-supply" data-testid="backup-supply-section" className="relative py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="relative rounded-2xl border border-white/10 bg-gradient-to-br from-volt/[0.05] via-transparent to-gold/[0.05] p-8 md:p-14 overflow-hidden">
            <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-volt/10 blur-[100px] pointer-events-none" />
            <SectionTag label="Backup Supply" />
            <div className="flex flex-col lg:flex-row lg:items-center gap-10 justify-between">
              <div className="max-w-2xl">
                <h2 className="font-outfit text-3xl md:text-5xl font-extralight tracking-tight text-white">
                  Your backup <span className="text-gold">energy supply network.</span>
                </h2>
                <p className="mt-5 text-white/60 text-base md:text-lg leading-relaxed">
                  Your existing supplier doesn&rsquo;t have to be your only option. Ajemi helps
                  you find alternative qualified supply when it matters most.
                </p>
                <div className="mt-7 flex flex-wrap gap-2.5" data-testid="backup-scenarios">
                  {SCENARIOS.map((s) => (
                    <span key={s} className="text-xs text-white/55 border border-white/12 rounded-full px-4 py-2">
                      {s}
                    </span>
                  ))}
                </div>
              </div>
              <button
                data-testid="backup-market-check-btn"
                onClick={() => scrollToId("market-check")}
                className="group shrink-0 inline-flex items-center gap-3 bg-gold text-ink font-outfit font-medium rounded-full pl-7 pr-2.5 py-2.5 hover:bg-goldbright hover:shadow-[0_0_40px_rgba(217,164,65,0.45)] transition-all duration-300"
              >
                <LifeBuoy className="w-4 h-4" />
                Start a Market Check
                <span className="bg-ink/10 rounded-full p-2 group-hover:rotate-45 transition-transform duration-300">
                  <ArrowUpRight className="w-4 h-4" />
                </span>
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
